export default __webpack_public_path__ + "static/retirement-planning-6-7792e6c153b2852bb848b3d8278fa902.png";